var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconwhiteDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.931,
    height: 14.4,
    viewBox: "0 0 13.931 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M43.253,155.481V159.1H33.19v-3.619H31.257v4.683a1.018,1.018,0,0,0,.969,1.063H44.22a1.019,1.019,0,0,0,.969-1.063v-4.683Z",
    transform: "translate(-31.257 -146.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M87.871,37.742l-3.046-3.683s-.465-.437.039-.437H86.58V28.26s-.07-.26.325-.26h2.416c.284,0,.279.219.279.219v5.291h1.585c.609,0,.15.457.15.457s-2.592,3.444-2.956,3.805a.337.337,0,0,1-.508-.031",
    transform: "translate(-81.1 -28)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconwhiteDownload);
export default __webpack_public_path__ + "static/media/IconwhiteDownload.faad883a.svg";
export { ForwardRef as ReactComponent };